import useIntl from '@/utils/intl'
import React, { FunctionComponent } from 'react'
import Image from 'next/image'
import { ArrowForwardIos } from '@mui/icons-material'
import { ServiceCategory, ServiceSubCategory } from '@/services/cms-api/service-menu/types'
import { useLanguage } from '@/context/LanguageContext'
import Link from 'next/link'
import { resolveImageUrl } from '@/utils/constants'

interface Prop {
  categories: ServiceCategory[]
  handleClose: () => void
}
const AppBarMenus: FunctionComponent<Prop> = ({ categories, handleClose }) => {
  const { translate } = useIntl()
  const { locale } = useLanguage()
  const [clicked, setClicked] = React.useState<number>()

  const additionalMenu = [
    {
      name: translate('shop.vatCorp'),
      icon: '/uploads/icons/corp.svg',
      url: 'https://business.mobicom.mn/',
      id: 'subMenu.corporation'
    },
    {
      name: 'Monpay',
      icon: '/uploads/icons/monpay.png',
      url: 'https://monpay.mn/',
      id: 'subMenu.monpay'
    },
    {
      name: 'Voo',
      icon: '/uploads/icons/voo.png',
      url: 'https://voo.mn/',
      id: 'subMenu.voo'
    },
    {
      name: 'mobilife',
      icon: '/images/mobilife.png',
      url: 'https://www.mobilife.mn/',
      id: 'subMenu.mobilife'
    }
  ]

  if (categories === undefined || categories === null) {
    return <></>
  }

  return (
    <div className='p-6 rounded-lg bg-secondaryMain absolute top-24 left-1/3 flex gap-8 text-textInverse'>
      <ul className='flex flex-col gap-4'>
        {categories.map((item, i) => (
          <li key={i} className='flex gap-2 justify-center items-center pl-2 pr-3 py-1 hover:bg-secondaryHighStroke rounded-lg cursor-pointer' onClick={() => setClicked(i)}>
            <div className='rounded-full border border-textLow p-2'>
              <Image draggable={false} src={resolveImageUrl(item.icon)} alt='?' width={16} height={16} className='w-5' />
            </div>
            <span className='text-sm w-36 text-textAdditional'>{locale === 'en' ? item.nameEn : item.nameMn}</span>
            <ArrowForwardIos className='text-xs text-textAdditional' />
          </li>
        ))}
        <div className='flex flex-col gap-4 border-t border-secondaryHighStroke border-dashed pt-4'>
          {
            additionalMenu.map((item, i) => (
              <Link id={item.id} key={i} href={item.url} rel='noopener noreferrer' target='_blank'>
                <li className='flex gap-2 items-center pl-2 pr-3 py-1 hover:bg-secondaryHighStroke rounded-lg cursor-pointer'>
                  <div className='rounded-full border border-textLow p-2 shadow-[inset_0_0_6px_0_rgba(250,250,250,0.36)] flex items-center justify-center'>
                    <div className='w-5 h-5 rounded-full overflow-hidden flex items-center justify-center'>
                      <Image
                        draggable={false}
                        width={12}
                        height={12}
                        src={
                          item.icon.startsWith('/images/')
                            ? item.icon
                            : resolveImageUrl(item.icon)
                        }
                        alt={item.name}
                        className={`object-cover ${
                          item.name === 'Mobilife'
                            ? 'scale-[1.6]'
                            : 'scale-100'
                        }`}
                      />
                    </div>
                  </div>
                  <span className='text-sm w-36 text-textAdditional'>{item.name}</span>
                </li>
              </Link>

            ))
          }
        </div>
      </ul>
      <ul>
        {
          clicked !== undefined && (
            categories[clicked]?.children?.map((item: ServiceSubCategory, i: number) => {
              return item.link !== null
                ? (
                  <Link key={i} href={item.link} rel='noopener noreferrer' target='_blank' onClick={handleClose}>
                    <li className='flex flex-col gap-2 justify-center items-start pl-2 pr-3 py-1 w-80 border-b border-dashed border-secondaryHighStroke'>
                      <span className='text-sm text-textAdditional p-2 hover:bg-secondaryHighStroke rounded-lg cursor-pointer'>{locale === 'en' ? item.nameEn : item.nameMn}</span>
                    </li>
                  </Link>
                  )
                : (
                  <Link id={item.nameEn.toLowerCase().split(' ').join('_')} key={i} href={item.link !== null ? item.link : `/service/${item.documentId}`} onClick={handleClose}>
                    <li className='flex flex-col gap-2 justify-center items-start pl-2 pr-3 py-1 w-80 border-b border-dashed border-secondaryHighStroke'>
                      <span className='text-sm p-2 hover:bg-secondaryHighStroke rounded-lg cursor-pointer text-textAdditional'>{locale === 'en' ? item.nameEn : item.nameMn}</span>
                    </li>
                  </Link>
                  )
            }))
        }
      </ul>
    </div>
  )
}
export default AppBarMenus
